export const wordsList = {
  Carro: ['Motor', 'Porta', 'Capô', 'Pneu', 'Antena'],
  Fruta: [
    'Banana',
    'Maçã',
    'Pêra',
    'Mamão',
    'Laranja',
    'Manga',
    'Uva',
    'Pera',
    'Mamao',
    'Abacate',
    'Abacaxi',
    'Acai',
    'Amora',
    'Caqui',
  ],
  Legumes: [
    'Cenoura',
    'Tomate',
    'Beterraba',
    'Mandioca',
    'Cebola',
    'Soja',
    'Nozes',
    'Alface',
  ],
  Corpo: [
    'Braço',
    'Perna',
    'Cérebro',
    'Pescoço',
    'Olhos',
    'Torax',
    'Pe',
    'Ombros',
  ],
  Computador: ['Mouse', 'Teclado', 'Monitor', 'Gabinete'],
  Programação: [
    'Linguagem',
    'Framework',
    'JavaScript',
    'React',
    'Angular',
    'Vue',
    'Python',
    'Ruby',
    'Go',
    'Node',
  ],
  Alimento: ['Arroz', 'Feijão', 'Carne', 'Ovo', 'Omelete', 'Batata', 'Milho'],
  Bebidas: [
    'Cerveja',
    'Leite',
    'Agua',
    'Cha',
    'Cafe',
    'Cocacola',
    'Guarana',
    'Sprite',
    'Iogurte',
  ],
  Alcoólico: [
    'Cerveja',
    'Vodka',
    'Whisky',
    'Espumante',
    'Vinho',
    'Absinto',
    'Rum',
    'Champanhe',
    'Licor',
    'Conhaque',
  ],
};
